import React, { useEffect, useRef, useState } from 'react';
import { Link } from 'react-router-dom'
import Carousel from 'react-multi-carousel';
import 'react-multi-carousel/lib/styles.css';

import BgImg from "../assets/images/bg/bg.png"
import Logo0 from "../assets/images/zoo-0.png"
import Logo1 from "../assets/images/zoo-1.png"
import Logo2 from "../assets/images/zoo-2.png"
import Logo3 from "../assets/images/zoo-3.png"
import Logo4 from "../assets/images/zoo-4.png"
import Logo5 from "../assets/images/zoo-5.png"
import Logo6 from "../assets/images/zoo-6.png"
import Logo7 from "../assets/images/zoo-7.png"

import PlusIcon from "../assets/images/icons/Plus.svg"
import ReduceIcon from "../assets/images/icons/Reduce.svg"
import FileIcon from "../assets/images/icons/file.svg"
import ArrowIcon from "../assets/images/icons/arrow.svg"

import LayoutHeader from '../layous/headers';
import Layoutfooter from '../layous/footer';


import { getBanners, getCategories, getYears, getZoos } from '../controllers/apicontroller';
import DOMPurify from 'dompurify'
import { formatThaiDate } from '../helps/functions';
import ProcurementContents from '../components/contents';

const zooData = [
    { 'id': 1, 'name': "องค์การสวนสัตว์แห่งประเทศไทย", src: Logo0, url: 'https://www.zoothailand.org/' },
    { 'id': 2, 'name': "สวนสัตว์เปิดเขาเขียว", src: Logo1, url: 'https://khaokheow.zoothailand.org/' },
    { 'id': 3, 'name': "สวนสัตว์เชียงใหม่", src: Logo2, url: 'https://chiangmai.zoothailand.org/' },
    { 'id': 4, 'name': "สวนสัตว์นครราชสีมา", src: Logo3, url: 'https://korat.zoothailand.org/' },
    { 'id': 5, 'name': "สวนสัตว์สงขลา", src: Logo4, url: 'https://songkhla.zoothailand.org/' },
    { 'id': 6, 'name': "สวนสัตว์อุบลราชธานี", src: Logo5, url: 'https://ubon.zoothailand.org/' },
    { 'id': 7, 'name': "โครงการคชอาณาจักร", src: Logo6, url: 'https://surin.zoothailand.org/' },
    { 'id': 8, 'name': "สวนสัตว์ขอนแก่น", src: Logo7, url: 'https://khonkaen.zoothailand.org/' },
]

const testdata = [
    {
        'name': 'O19 แผนการจัดซื้อจัดจ้างหรือแผนการจัดหาพัสดุ',
        'sub': [
            { 'name': 'ประกาศแผนจ้างที่ปรึกษาจัดทำบัญชีข้อมูลองค์กร (Data Catalog) องค์การสวนสัตว์แห่งประเทศไทย' },
            { 'name': 'สวนสัตว์ขอนแก่น ประกาศเผยแพร่การจัดจ้างเหมาบริการรักษาความปลอดภัย ประจำปีงบประมาณ 2568' },
            { 'name': 'ประกาศสวนสัตว์เชียงใหม่ เรื่อง เผยแพร่แผนการจัดซื้อจัดจ้าง ประจำปีงบประมาณ พ.ศ. 2568' },
            { 'name': 'องค์การสวนสัตว์แห่งประเทศไทย ประกาศเผยแพร่แผนการจัดซื้อเครื่องเพิ่มปริมาณสารพันธุกรรมและตรวจวัดในสภาพจริง (Real-time PCR detection system) จำนวน ๑ เครื่อง ประจำปีงบประมาณ ๒๕๖๘ (งบรัฐบาล)' },
            { 'name': 'ประกาศแผนจัดซื้อจัดจ้างอาหารสัตว์ ประจำปีงบประมาณ 2568 โครงการคชอาณาจักร จังหวัดสุรินทร์' },
            { 'name': 'ประกาศแผนจ้างที่ปรึกษาจัดทำบัญชีข้อมูลองค์กร (Data Catalog) องค์การสวนสัตว์แห่งประเทศไทย' },
            { 'name': 'สวนสัตว์ขอนแก่น ประกาศเผยแพร่การจัดจ้างเหมาบริการรักษาความปลอดภัย ประจำปีงบประมาณ 2568' },
            { 'name': 'ประกาศสวนสัตว์เชียงใหม่ เรื่อง เผยแพร่แผนการจัดซื้อจัดจ้าง ประจำปีงบประมาณ พ.ศ. 2568' },
            { 'name': 'องค์การสวนสัตว์แห่งประเทศไทย ประกาศเผยแพร่แผนการจัดซื้อเครื่องเพิ่มปริมาณสารพันธุกรรมและตรวจวัดในสภาพจริง (Real-time PCR detection system) จำนวน ๑ เครื่อง ประจำปีงบประมาณ ๒๕๖๘ (งบรัฐบาล)' },
            { 'name': 'ประกาศแผนจัดซื้อจัดจ้างอาหารสัตว์ ประจำปีงบประมาณ 2568 โครงการคชอาณาจักร จังหวัดสุรินทร์' },
        ]
    },
    {
        'name': 'O21 สรุปผลการจัดซื้อจัดจ้างหรือการจัดหาพัสดุรายเดือน',
        'sub': [
            { 'name': 'ประกาศแผนจ้างที่ปรึกษาจัดทำบัญชีข้อมูลองค์กร (Data Catalog) องค์การสวนสัตว์แห่งประเทศไทย' },
            { 'name': 'สวนสัตว์ขอนแก่น ประกาศเผยแพร่การจัดจ้างเหมาบริการรักษาความปลอดภัย ประจำปีงบประมาณ 2568' },
            { 'name': 'ประกาศสวนสัตว์เชียงใหม่ เรื่อง เผยแพร่แผนการจัดซื้อจัดจ้าง ประจำปีงบประมาณ พ.ศ. 2568' },
            { 'name': 'องค์การสวนสัตว์แห่งประเทศไทย ประกาศเผยแพร่แผนการจัดซื้อเครื่องเพิ่มปริมาณสารพันธุกรรมและตรวจวัดในสภาพจริง (Real-time PCR detection system) จำนวน ๑ เครื่อง ประจำปีงบประมาณ ๒๕๖๘ (งบรัฐบาล)' },
            { 'name': 'ประกาศแผนจัดซื้อจัดจ้างอาหารสัตว์ ประจำปีงบประมาณ 2568 โครงการคชอาณาจักร จังหวัดสุรินทร์' },
            { 'name': 'ประกาศแผนจ้างที่ปรึกษาจัดทำบัญชีข้อมูลองค์กร (Data Catalog) องค์การสวนสัตว์แห่งประเทศไทย' },
            { 'name': 'สวนสัตว์ขอนแก่น ประกาศเผยแพร่การจัดจ้างเหมาบริการรักษาความปลอดภัย ประจำปีงบประมาณ 2568' },
            { 'name': 'ประกาศสวนสัตว์เชียงใหม่ เรื่อง เผยแพร่แผนการจัดซื้อจัดจ้าง ประจำปีงบประมาณ พ.ศ. 2568' },
            { 'name': 'องค์การสวนสัตว์แห่งประเทศไทย ประกาศเผยแพร่แผนการจัดซื้อเครื่องเพิ่มปริมาณสารพันธุกรรมและตรวจวัดในสภาพจริง (Real-time PCR detection system) จำนวน ๑ เครื่อง ประจำปีงบประมาณ ๒๕๖๘ (งบรัฐบาล)' },
            { 'name': 'ประกาศแผนจัดซื้อจัดจ้างอาหารสัตว์ ประจำปีงบประมาณ 2568 โครงการคชอาณาจักร จังหวัดสุรินทร์' },
        ]
    },
    {
        'name': 'O22 รายงานผลการจัดซื้อจัดจ้างหรือการจัดหาพัสดุประจำปี',
        'sub': [
            { 'name': 'ประกาศแผนจ้างที่ปรึกษาจัดทำบัญชีข้อมูลองค์กร (Data Catalog) องค์การสวนสัตว์แห่งประเทศไทย' },
            { 'name': 'สวนสัตว์ขอนแก่น ประกาศเผยแพร่การจัดจ้างเหมาบริการรักษาความปลอดภัย ประจำปีงบประมาณ 2568' },
            { 'name': 'ประกาศสวนสัตว์เชียงใหม่ เรื่อง เผยแพร่แผนการจัดซื้อจัดจ้าง ประจำปีงบประมาณ พ.ศ. 2568' },
            { 'name': 'องค์การสวนสัตว์แห่งประเทศไทย ประกาศเผยแพร่แผนการจัดซื้อเครื่องเพิ่มปริมาณสารพันธุกรรมและตรวจวัดในสภาพจริง (Real-time PCR detection system) จำนวน ๑ เครื่อง ประจำปีงบประมาณ ๒๕๖๘ (งบรัฐบาล)' },
            { 'name': 'ประกาศแผนจัดซื้อจัดจ้างอาหารสัตว์ ประจำปีงบประมาณ 2568 โครงการคชอาณาจักร จังหวัดสุรินทร์' },
            { 'name': 'ประกาศแผนจ้างที่ปรึกษาจัดทำบัญชีข้อมูลองค์กร (Data Catalog) องค์การสวนสัตว์แห่งประเทศไทย' },
            { 'name': 'สวนสัตว์ขอนแก่น ประกาศเผยแพร่การจัดจ้างเหมาบริการรักษาความปลอดภัย ประจำปีงบประมาณ 2568' },
            { 'name': 'ประกาศสวนสัตว์เชียงใหม่ เรื่อง เผยแพร่แผนการจัดซื้อจัดจ้าง ประจำปีงบประมาณ พ.ศ. 2568' },
            { 'name': 'องค์การสวนสัตว์แห่งประเทศไทย ประกาศเผยแพร่แผนการจัดซื้อเครื่องเพิ่มปริมาณสารพันธุกรรมและตรวจวัดในสภาพจริง (Real-time PCR detection system) จำนวน ๑ เครื่อง ประจำปีงบประมาณ ๒๕๖๘ (งบรัฐบาล)' },
            { 'name': 'ประกาศแผนจัดซื้อจัดจ้างอาหารสัตว์ ประจำปีงบประมาณ 2568 โครงการคชอาณาจักร จังหวัดสุรินทร์' },
        ]
    },
    {
        'name': '015 ประกาศต่าง ๆ เกี่ยวกับการจัดซื้อจัดจ้างหรือการจัดหาพัสดุ',
        'sub': [
            { 'name': 'ประกาศแผนจ้างที่ปรึกษาจัดทำบัญชีข้อมูลองค์กร (Data Catalog) องค์การสวนสัตว์แห่งประเทศไทย' },
            { 'name': 'สวนสัตว์ขอนแก่น ประกาศเผยแพร่การจัดจ้างเหมาบริการรักษาความปลอดภัย ประจำปีงบประมาณ 2568' },
            { 'name': 'ประกาศสวนสัตว์เชียงใหม่ เรื่อง เผยแพร่แผนการจัดซื้อจัดจ้าง ประจำปีงบประมาณ พ.ศ. 2568' },
            { 'name': 'องค์การสวนสัตว์แห่งประเทศไทย ประกาศเผยแพร่แผนการจัดซื้อเครื่องเพิ่มปริมาณสารพันธุกรรมและตรวจวัดในสภาพจริง (Real-time PCR detection system) จำนวน ๑ เครื่อง ประจำปีงบประมาณ ๒๕๖๘ (งบรัฐบาล)' },
            { 'name': 'ประกาศแผนจัดซื้อจัดจ้างอาหารสัตว์ ประจำปีงบประมาณ 2568 โครงการคชอาณาจักร จังหวัดสุรินทร์' },
            { 'name': 'ประกาศแผนจ้างที่ปรึกษาจัดทำบัญชีข้อมูลองค์กร (Data Catalog) องค์การสวนสัตว์แห่งประเทศไทย' },
            { 'name': 'สวนสัตว์ขอนแก่น ประกาศเผยแพร่การจัดจ้างเหมาบริการรักษาความปลอดภัย ประจำปีงบประมาณ 2568' },
            { 'name': 'ประกาศสวนสัตว์เชียงใหม่ เรื่อง เผยแพร่แผนการจัดซื้อจัดจ้าง ประจำปีงบประมาณ พ.ศ. 2568' },
            { 'name': 'องค์การสวนสัตว์แห่งประเทศไทย ประกาศเผยแพร่แผนการจัดซื้อเครื่องเพิ่มปริมาณสารพันธุกรรมและตรวจวัดในสภาพจริง (Real-time PCR detection system) จำนวน ๑ เครื่อง ประจำปีงบประมาณ ๒๕๖๘ (งบรัฐบาล)' },
            { 'name': 'ประกาศแผนจัดซื้อจัดจ้างอาหารสัตว์ ประจำปีงบประมาณ 2568 โครงการคชอาณาจักร จังหวัดสุรินทร์' },
        ]
    },
    {
        'name': ' สัญญาจัดซื้อจัดจ้าง',
        'sub': [
            { 'name': 'ประกาศแผนจ้างที่ปรึกษาจัดทำบัญชีข้อมูลองค์กร (Data Catalog) องค์การสวนสัตว์แห่งประเทศไทย' },
            { 'name': 'สวนสัตว์ขอนแก่น ประกาศเผยแพร่การจัดจ้างเหมาบริการรักษาความปลอดภัย ประจำปีงบประมาณ 2568' },
            { 'name': 'ประกาศสวนสัตว์เชียงใหม่ เรื่อง เผยแพร่แผนการจัดซื้อจัดจ้าง ประจำปีงบประมาณ พ.ศ. 2568' },
            { 'name': 'องค์การสวนสัตว์แห่งประเทศไทย ประกาศเผยแพร่แผนการจัดซื้อเครื่องเพิ่มปริมาณสารพันธุกรรมและตรวจวัดในสภาพจริง (Real-time PCR detection system) จำนวน ๑ เครื่อง ประจำปีงบประมาณ ๒๕๖๘ (งบรัฐบาล)' },
            { 'name': 'ประกาศแผนจัดซื้อจัดจ้างอาหารสัตว์ ประจำปีงบประมาณ 2568 โครงการคชอาณาจักร จังหวัดสุรินทร์' },
            { 'name': 'ประกาศแผนจ้างที่ปรึกษาจัดทำบัญชีข้อมูลองค์กร (Data Catalog) องค์การสวนสัตว์แห่งประเทศไทย' },
            { 'name': 'สวนสัตว์ขอนแก่น ประกาศเผยแพร่การจัดจ้างเหมาบริการรักษาความปลอดภัย ประจำปีงบประมาณ 2568' },
            { 'name': 'ประกาศสวนสัตว์เชียงใหม่ เรื่อง เผยแพร่แผนการจัดซื้อจัดจ้าง ประจำปีงบประมาณ พ.ศ. 2568' },
            { 'name': 'องค์การสวนสัตว์แห่งประเทศไทย ประกาศเผยแพร่แผนการจัดซื้อเครื่องเพิ่มปริมาณสารพันธุกรรมและตรวจวัดในสภาพจริง (Real-time PCR detection system) จำนวน ๑ เครื่อง ประจำปีงบประมาณ ๒๕๖๘ (งบรัฐบาล)' },
            { 'name': 'ประกาศแผนจัดซื้อจัดจ้างอาหารสัตว์ ประจำปีงบประมาณ 2568 โครงการคชอาณาจักร จังหวัดสุรินทร์' },
        ]
    },
    {
        'name': ' คู่มือการดำเนินการตามพระราชบัญญัติการจัดซื้อจัดจ้างและการบริหารพัสดุภาครัฐ พ.ศ. 2560',
        'sub': [
            { 'name': 'ประกาศแผนจ้างที่ปรึกษาจัดทำบัญชีข้อมูลองค์กร (Data Catalog) องค์การสวนสัตว์แห่งประเทศไทย' },
            { 'name': 'สวนสัตว์ขอนแก่น ประกาศเผยแพร่การจัดจ้างเหมาบริการรักษาความปลอดภัย ประจำปีงบประมาณ 2568' },
            { 'name': 'ประกาศสวนสัตว์เชียงใหม่ เรื่อง เผยแพร่แผนการจัดซื้อจัดจ้าง ประจำปีงบประมาณ พ.ศ. 2568' },
            { 'name': 'องค์การสวนสัตว์แห่งประเทศไทย ประกาศเผยแพร่แผนการจัดซื้อเครื่องเพิ่มปริมาณสารพันธุกรรมและตรวจวัดในสภาพจริง (Real-time PCR detection system) จำนวน ๑ เครื่อง ประจำปีงบประมาณ ๒๕๖๘ (งบรัฐบาล)' },
            { 'name': 'ประกาศแผนจัดซื้อจัดจ้างอาหารสัตว์ ประจำปีงบประมาณ 2568 โครงการคชอาณาจักร จังหวัดสุรินทร์' },
            { 'name': 'ประกาศแผนจ้างที่ปรึกษาจัดทำบัญชีข้อมูลองค์กร (Data Catalog) องค์การสวนสัตว์แห่งประเทศไทย' },
            { 'name': 'สวนสัตว์ขอนแก่น ประกาศเผยแพร่การจัดจ้างเหมาบริการรักษาความปลอดภัย ประจำปีงบประมาณ 2568' },
            { 'name': 'ประกาศสวนสัตว์เชียงใหม่ เรื่อง เผยแพร่แผนการจัดซื้อจัดจ้าง ประจำปีงบประมาณ พ.ศ. 2568' },
            { 'name': 'องค์การสวนสัตว์แห่งประเทศไทย ประกาศเผยแพร่แผนการจัดซื้อเครื่องเพิ่มปริมาณสารพันธุกรรมและตรวจวัดในสภาพจริง (Real-time PCR detection system) จำนวน ๑ เครื่อง ประจำปีงบประมาณ ๒๕๖๘ (งบรัฐบาล)' },
            { 'name': 'ประกาศแผนจัดซื้อจัดจ้างอาหารสัตว์ ประจำปีงบประมาณ 2568 โครงการคชอาณาจักร จังหวัดสุรินทร์' },
        ]
    },
    {
        'name': 'กฎหมาย ระเบียบ ข้อบังคับ ประกาศต่างๆ',
        'sub': [
            { 'name': 'ประกาศแผนจ้างที่ปรึกษาจัดทำบัญชีข้อมูลองค์กร (Data Catalog) องค์การสวนสัตว์แห่งประเทศไทย' },
            { 'name': 'สวนสัตว์ขอนแก่น ประกาศเผยแพร่การจัดจ้างเหมาบริการรักษาความปลอดภัย ประจำปีงบประมาณ 2568' },
            { 'name': 'ประกาศสวนสัตว์เชียงใหม่ เรื่อง เผยแพร่แผนการจัดซื้อจัดจ้าง ประจำปีงบประมาณ พ.ศ. 2568' },
            { 'name': 'องค์การสวนสัตว์แห่งประเทศไทย ประกาศเผยแพร่แผนการจัดซื้อเครื่องเพิ่มปริมาณสารพันธุกรรมและตรวจวัดในสภาพจริง (Real-time PCR detection system) จำนวน ๑ เครื่อง ประจำปีงบประมาณ ๒๕๖๘ (งบรัฐบาล)' },
            { 'name': 'ประกาศแผนจัดซื้อจัดจ้างอาหารสัตว์ ประจำปีงบประมาณ 2568 โครงการคชอาณาจักร จังหวัดสุรินทร์' },
            { 'name': 'ประกาศแผนจ้างที่ปรึกษาจัดทำบัญชีข้อมูลองค์กร (Data Catalog) องค์การสวนสัตว์แห่งประเทศไทย' },
            { 'name': 'สวนสัตว์ขอนแก่น ประกาศเผยแพร่การจัดจ้างเหมาบริการรักษาความปลอดภัย ประจำปีงบประมาณ 2568' },
            { 'name': 'ประกาศสวนสัตว์เชียงใหม่ เรื่อง เผยแพร่แผนการจัดซื้อจัดจ้าง ประจำปีงบประมาณ พ.ศ. 2568' },
            { 'name': 'องค์การสวนสัตว์แห่งประเทศไทย ประกาศเผยแพร่แผนการจัดซื้อเครื่องเพิ่มปริมาณสารพันธุกรรมและตรวจวัดในสภาพจริง (Real-time PCR detection system) จำนวน ๑ เครื่อง ประจำปีงบประมาณ ๒๕๖๘ (งบรัฐบาล)' },
            { 'name': 'ประกาศแผนจัดซื้อจัดจ้างอาหารสัตว์ ประจำปีงบประมาณ 2568 โครงการคชอาณาจักร จังหวัดสุรินทร์' },
        ]
    },
]

const Procurement = () => {
    const currentYear = new Date().getFullYear();
    const [loaded, setLoaded] = useState(false)
    const [category, setCategory] = useState([])

    const [zoo, setZoo] = useState(zooData[0].name)
    const [dataTest, setDataTest] = useState([])
    const [dataActive, setDataActive] = useState({ index: 0, status: true })

    const [zoos, setZoos] = useState([])
    const [contents, setContents] = useState([])
    const [years, setYears] = useState([])
    const [listactive, setListactive] = useState(0)
    const [year, setYear] = useState(currentYear)
    let componentMounted = useRef(true);
    const procurementRef = useRef(null)
    useEffect(() => {
        if (componentMounted.current) {
            init()

            setDataTest(testdata);
        }

        return () => {
            componentMounted.current = false;
        }
    }, [])
    const init = async () => {
        setLoaded(false)
        await fetchCategory(currentYear)
        await fetchYears()
        await fetchZoos()
        setLoaded(true)
    }

    const fetchCategory = async (year) => {
        const response = await getCategories(`?type=ita-purchase&year=${year}&content-by=writing_date`)
        if (response.status == 200) {
            const data = await response.json()
         //  console.log('fetch category ', data.data)
            setCategory(data.data)
            if (data.data.length > 0 && data.data[0].contents.length > 0)
                setContents(data.data[0].contents)
        }

    }
    const fetchYears = async () => {
        const response = await getYears(`?type=ita-purchase`)
        if (response.status == 200) {
            const data = await response.json()
            setYears(data)
        }

    }
    const fetchZoos = async() => {
        const response =  await getZoos()
        if (response.status == 200) {
            const data = await response.json()
            console.log('fetch zoos : ', data.data)
            const zoosData = data.data
            setZoos(zoosData)
            setZoo(zoosData[0])
        }

    }
    const changeYear = async (e) => {
        setLoaded(false)
        await fetchCategory(e.target.value)
        setYear(e.target.value)
        setLoaded(true)

    }
    const handleClickProcurement = (e, idx) => {
        const cate = category.find((ele, index) => index === idx)
        e.preventDefault();
        setLoaded(false)
        setContents(cate.contents)
        setListactive(idx)
        setLoaded(true)
    }

    const handleClickZoo = async(e) => {
        const zooData = zoos.find((_,i) => i == e)
        console.log('zoo data : ', zooData, ' e : ', e)
        if(!zooData) return null
        setZoo(zooData)
        if(zooData.main != 1 ){
            const newCategory = category.map((cate) => {
                console.log('cate : ', cate, ' zoo data id : ', zooData.id)
                const contents = cate.contents.filter(x => x.zoo && x.zoo.id == zooData.id)
                return {
                    ...cate,
                    contents: contents ?? []
                }
            })
            setCategory(newCategory)
        }else{
            await fetchCategory(year)
        }
        procurementRef.current.scrollIntoView({ behavior: "smooth" });

    }

    const handleClick = (e) => {
        dataActive.index === e && dataActive.status === true ?
            setDataActive({ index: e, status: false })
            : setDataActive({ index: e, status: true })
    }


 //  console.log(dataActive)
    return (
        <>
            <LayoutHeader />
            <section className="header-title"></section>
            {/* Content Details */}
            {(loaded) && <>
                <h1 className='fw-bold text-green  font-kanit py-5'>ข้อมูลจัดซื้อจัดจ้าง</h1>
                <div className="container">
                    <div className='row justify-content-center'>
                        <div className="col-md-11 col-lg-10">
                            <div className="row" id="">
                                {zoos?.map((val, index) => (
                                    <div className="col-6 col-md-3 col-lg-3" key={index}>
                                        <button className='btn' onClick={e => handleClickZoo(index)}><img src={val.logo} className="w-100 p-3" /></button>
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>
                </div>

                <section id="item-list" style={{ backgroundImage: `url(${BgImg})`, backgroundPosition: "center center", backgroundSize: "cover", backgroundRepeat: "no-repeat" }}>
                    <div className="container">
                        {/* <div className="mt-4 mb-3" id="">
                        <div className='d-flex flex-row-reverse' >
                            <select className="form-select d-inline-block form-select-custom font-kanit" 
                                onChange={e => changeYear(e)}
                                value={year}
                            >
                                <option>เลือกปี</option>
                                {years?.map((opt,y) => (
                                    <option value={opt.year} key={y}>ปี {Number(opt.year)+543}</option>
                                ))}
                            </select>
                        </div>
                    </div>
                    <div className='text-start pb-4'>
                        <h2 className='fw-bolder text-green  font-kanit'>ข้อมูลการจัดซื้อจัดจ้าง ปี {Number(year)+543}</h2>
                        <div className='w-75 hr-custom' style={{height: "3px"}}></div>
                    </div>
                    <div className="row grid mb-2" id="ita-result">
                        <div className="col-md-4 col-lg-4">
                          <div className="list-group text-start" id="purchase-side">
                              {category?.map((cate,c) => (
                                <a href="#" onClick={e => handleClickProcurement(e,c)} key={c} className={`list-group-item list-group-item-action ${listactive == c ? 'active' : ''}`} aria-current="true">{cate.name}</a>
                              ))}
                          </div>
                        </div>
                        <div className="col-md-8 col-lg-8">
                          {contents.length > 1 ?
                            <div className="container">
                              <div className="mt-2 text-start">
                              <ul className="dash-list">
                              {contents.map((item,i) => (
                                  <li key={i}><Link to={`/view/procurement/${item.id}`} className='fs-5'>{item.subject}</Link></li>
                              ))}
                              </ul>
                            </div>
                            </div>
                          : null }
                          {contents.length == 1 &&
                          <div className="mb-2">
                              <div className='text-start pb-4'>
                                  <h4 className='fw-bolder text-green  font-kanit'>{contents[0].subject}</h4>
                                  <div className='w-75 hr-custom' style={{height: "3px"}}></div>
                              </div>
                              <div className="text-start grid mb-2" id="ita-result">
                                  <div dangerouslySetInnerHTML={{__html: DOMPurify.sanitize(contents[0].detail)}}></div>
                              </div>
                              {contents[0].documents.length > 0 ? 
                                <div className="mt-2 text-start">
                                  <ul className="dash-list">
                                    {contents[0].documents.map((doc,d) => (
                                      <li key={d} className='text-start'><Link to={doc.original_url}>{doc.file_name}</Link></li>
                                    ))}
                                  </ul>
                                </div>
                              : null }
                          </div>
                          }
                      </div>
                    </div> */}

                        <div className="row mb-2 mt-5" id="" ref={procurementRef}>
                            <div className="col-md-12 col-lg-12 text-start">
                                <h2 className='text-green font-kanit fw-normal'> ข้อมูลจัดซื้อจัดจ้าง / <span className='fw-bold'>{zoo?.name}</span></h2>
                                <div className="w-75 hr-custom" style={{ height: '3px' }}></div>
                            </div>

                        </div>
                        <div className="mt-4 mb-3" id="">
                        <div className='d-flex flex-row-reverse' >
                            <select className="form-select d-inline-block form-select-custom font-kanit" value={year} onChange={e => changeYear(e)}>
                                <option>เลือกปี</option>
                                {years?.map((opt,y) => (
                                    <option value={opt.year} key={y}>ปี {Number(opt.year)+543}</option>
                                ))}
                            </select>
                        </div>
                    </div>
                        <div className='row mt-5'>

                            {category?.map((val, index) => (
                                <div className="col-md-12 col-lg-12 col-sm-12 mb-2 grid-item px-3" key={index}>
                                    <a className={`article-title d-flex text-start ${index === dataActive.index && dataActive.status ? "active" : "deactive"}`} role="button" onClick={e => handleClick(index)}>
                                        <img src={PlusIcon} className={`me-2 float-left menu-icon-plus ${index === dataActive.index && dataActive.status ? "d-none" : "d-inline-block"}`} />
                                        <img src={ReduceIcon} className={`me-2 float-left menu-icon-reduce ${index === dataActive.index && dataActive.status ? "d-inline-block" : "d-none"}`} />
                                        <div className="ms-1 float-left"> {val.name}</div>
                                    </a>
                                    <div className={`collapse ${index === dataActive.index && dataActive.status ? "show" : "hide"}`} id="tab-0">
                                        <div className="card card-body text-start p-0">
                                            {/* <ul className="list-group">
                                                {val.contents?.map((vall, indexx) => (
                                                    <li key={indexx} className="list-group-item ps-4 position-relative">
                                                        <Link to={`/view/ita-procurement/${vall.id}`} className="d-flex text-start ">
                                                            <div className='row w-100'>
                                                                <div className='col-md-8 col-sm-8 ps-4'>
                                                                    <img src={FileIcon} className="me-2 position-absolute" style={{left:'10px'}} />{vall.subject}
                                                                </div>
                                                                <div className='col-md-4 col-sm-4 text-end'>
                                                                    <span className='pull-end'>{formatThaiDate(vall.writing_date) }</span>
                                                                </div>
                                                            </div>
                                                        </Link>
                                                    </li>
                                                ))}
                                            </ul> */}
                                            <ProcurementContents contents={val.contents} />
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>
                        <div className='mt-5'>
                            {/* <nav className='text-center'>
                                <ul className="pagination justify-content-center">
                                    <li className="page-item">
                                        <a className="page-link" href="#" aria-label="Previous">
                                        <span aria-hidden="true"><img src={ArrowIcon} style={{height:'12px',transform: 'rotate(180deg)'}}/></span>
                                        </a>
                                    </li>
                                    <li className="page-item"><a className="page-link" href="#">1</a></li>
                                    <li className="page-item"><a className="page-link" href="#">2</a></li>
                                    <li className="page-item"><a className="page-link" href="#">3</a></li>
                                    <li className="page-item">
                                        <a className="page-link" href="#" aria-label="Next">
                                            <span aria-hidden="true"><img src={ArrowIcon} style={{height:'12px'}}/></span>
                                        </a>
                                    </li>
                                </ul>
                            </nav> */}
                        </div>
                    </div>
                </section>
            </>
            }
            {/* Content Details */}
            <Layoutfooter />
        </>
    )
}

export default Procurement